import React from "react";
import { getCartQuantityFromProductId } from "../../helper";
import "./styles.scss";

export default function AddToCart(props) {
  const {
    addToCart,
    element,
    cartQuantity,
    search,
    isMobile,
    packaging,
    setProductQuantity,
    cart,
    setNewlyAdded,
    backend,
  } = props;

  const handleUpdateProductQuantity = () => {
    const quantity = getCartQuantityFromProductId(
      cart,
      element,
      element.rate_amt === null
    );
    setProductQuantity(quantity);
  };

  return (
    <div
      className="cart-button"
      style={{ width: isMobile ? "100%" : "10vw" }}
      onClick={(event) => {
        if (!search) {
          event.stopPropagation();
          event.preventDefault();
        }

        if (cartQuantity === 0 || cartQuantity === null) {
          !(packaging !== null && cartQuantity) && element.rate_amt
            ? addToCart(element, null, packaging)
            : addToCart(element);
          handleUpdateProductQuantity();
          backend && setNewlyAdded(true);
        }
      }}
    >
      {cartQuantity > 0 ? (
        <>
          <div
            className="cart-action-button decrement"
            onClick={(event) => {
              if (!search) {
                event.preventDefault();
                event.stopPropagation();
              }
              element.rate_amt
                ? addToCart(element, Number(cartQuantity) - 1, packaging)
                : addToCart(element, Number(cartQuantity) - 1);
              handleUpdateProductQuantity();
            }}
          >
            -
          </div>
          <div
            className="cart-quantity"
            onClick={(event) => event.stopPropagation()}
          >
            {cartQuantity}
          </div>
          <div
            className="cart-action-button"
            onClick={(event) => {
              if (!search) {
                event.stopPropagation();
                event.preventDefault();
              }
              element.rate_amt
                ? addToCart(element, Number(cartQuantity) + 1, packaging)
                : addToCart(
                    element,
                    cartQuantity ? Number(cartQuantity) + 1 : 1
                  );
              handleUpdateProductQuantity();
            }}
          >
            +
          </div>
        </>
      ) : (
        <>Add To Cart</>
      )}
    </div>
  );
}
